module.exports = __webpack_public_path__ + "static/media/key-purple.f07a1961.svg";